import uri from 'urijs';
import { createAction, USER_ID_TYPE_OWNER, USER_ID_TYPE_SITE_MEMBER } from '@wix/communities-blog-client-common';

import { debug } from '../services/debug';
import { getUserCommentsCursor } from '../selectors/user-comments-selectors';

export const FETCH_USER_COMMENTS_REQUEST = 'userComments/FETCH_REQUEST';
export const FETCH_USER_COMMENTS_SUCCESS = 'userComments/FETCH_SUCCESS';
export const FETCH_USER_COMMENTS_FAILURE = 'userComments/FETCH_FAILURE';

export const fetchProfileCommentsRequest = createAction(
  FETCH_USER_COMMENTS_REQUEST,
  (payload) => payload,
  (payload, meta) => meta,
);
export const fetchProfileCommentsSuccess = createAction(
  FETCH_USER_COMMENTS_SUCCESS,
  (payload) => payload,
  (payload, meta) => meta,
);
export const fetchProfileCommentsFailure = createAction(
  FETCH_USER_COMMENTS_FAILURE,
  (payload) => payload,
  (payload, meta) => meta,
);

export const fetchComments = ({ userIdType = USER_ID_TYPE_OWNER, id, page, pageSize }) => {
  return (dispatch, getState, { request }) => {
    dispatch(fetchProfileCommentsRequest({ userIdType, id }));

    return fetchCommentsServiceComments(userIdType, id, page, pageSize, dispatch, getState, request);
  };
};

function fetchCommentsServiceComments(userIdType, id, page, pageSize, dispatch, getState, request) {
  const commentsCursor = getUserCommentsCursor(getState());
  const params = { limit: pageSize, cursor: commentsCursor };
  const promise = request(uri(`_api/member-comments-server/comments/member/${id}`).query(params), {
    parseHeaders: true,
    apiBaseUrl: '/',
  });

  return promise
    .then(({ body = {} }) =>
      dispatch(
        fetchProfileCommentsSuccess(mapCommentsToViewModel(body.comments, body.member, body.contextTokens), {
          page,
          cursor: body.nextPage,
        }),
      ),
    )
    .catch((error) => {
      debug.error('fetchComments', error);
      dispatch(fetchProfileCommentsFailure({ userIdType, id }));
    })
    .then(() => promise);
}

function mapCommentsToViewModel(comments, member, contextTokens) {
  const owner = {
    image: member.profile.photo && member.profile.photo.url,
    name: member.profile.nickname,
    privacyStatus: member.privacyStatus,
    siteMemberId: member.id,
    slug: member.profile.slug,
  };

  return comments.map(({ comment, post }) => ({
    post,
    owner,
    ...comment,
    _id: comment.commentId,
    content: JSON.parse(comment.comment.text.content),
    createdDate: comment.createdAt,
    instanceId: comment.commentId,
    postId: post.id,
    contextToken: contextTokens[post._id],
  }));
}

export function fetchCommentsBySiteMemberId({ siteMemberId, page, pageSize }) {
  return fetchComments({
    userIdType: USER_ID_TYPE_SITE_MEMBER,
    id: siteMemberId,
    page,
    pageSize,
  });
}
